(function () {
  var STAR_ICON =
    '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">' +
    '<path d="M10 1.5l2.6 5.6 6.1.7-4.5 4.2 1.2 6-5.4-3-5.4 3 1.2-6-4.5-4.2 6.1-.7z"/>' +
    '</svg>';
  var STAR_ROW = STAR_ICON.repeat(5);

  function starsEl(rating) {
    var wrap = document.createElement('span');
    wrap.className = 'cl-stars__track';
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', rating.toFixed(1) + ' out of 5 stars');
    wrap.innerHTML = STAR_ROW;

    var fill = document.createElement('span');
    fill.className = 'cl-stars__fill';
    fill.style.width = Math.max(0, Math.min(100, (rating / 5) * 100)) + '%';
    fill.innerHTML = STAR_ROW;
    wrap.appendChild(fill);
    return wrap;
  }

  function renderSummary(root, data) {
    root.querySelector('[data-cl-reviews-avg]').textContent = data.average.toFixed(1);
    root.querySelector('[data-cl-reviews-count]').textContent = data.count.toLocaleString() + ' verified reviews';

    var starsHost = root.querySelector('[data-cl-reviews-stars]');
    starsHost.innerHTML = '';
    starsHost.appendChild(starsEl(data.average));

    var histogram = root.querySelector('[data-cl-reviews-histogram]');
    histogram.innerHTML = '';
    [5, 4, 3, 2, 1].forEach(function (star) {
      var pct = (data.histogram_pct && data.histogram_pct[star]) || 0;
      var row = document.createElement('div');
      row.className = 'cl-reviews__hist-row';

      var label = document.createElement('span');
      label.textContent = star + '★';

      var track = document.createElement('span');
      track.className = 'cl-reviews__hist-track';
      var fill = document.createElement('span');
      fill.className = 'cl-reviews__hist-fill';
      fill.style.width = pct + '%';
      track.appendChild(fill);

      var pctLabel = document.createElement('span');
      pctLabel.textContent = pct + '%';

      row.appendChild(label);
      row.appendChild(track);
      row.appendChild(pctLabel);
      histogram.appendChild(row);
    });
  }

  function renderCards(root, reviews) {
    var grid = root.querySelector('[data-cl-reviews-grid]');
    grid.innerHTML = '';
    reviews.forEach(function (r) {
      var card = document.createElement('blockquote');
      card.className = 'cl-reviews__card';

      var starsHost = document.createElement('div');
      starsHost.className = 'cl-reviews__card-stars';
      starsHost.appendChild(starsEl(r.rating));
      card.appendChild(starsHost);

      if (r.title) {
        var title = document.createElement('p');
        title.className = 'cl-reviews__card-title';
        title.textContent = r.title;
        card.appendChild(title);
      }

      var body = document.createElement('p');
      body.className = 'cl-reviews__card-body';
      body.textContent = r.body;
      card.appendChild(body);

      var footer = document.createElement('footer');
      footer.className = 'cl-reviews__card-footer';
      var name = document.createElement('strong');
      name.textContent = r.reviewer_name;
      footer.appendChild(name);
      if (r.verified) {
        footer.appendChild(document.createTextNode(' · '));
        var badge = document.createElement('span');
        badge.className = 'cl-reviews__card-verified';
        badge.textContent = 'Verified buyer';
        footer.appendChild(badge);
      }
      card.appendChild(footer);

      grid.appendChild(card);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cl-reviews]').forEach(function (root) {
      var endpoint = root.getAttribute('data-endpoint');
      var productIds = root.getAttribute('data-product-ids');
      var maxQuotes = parseInt(root.getAttribute('data-max-quotes'), 10) || 6;
      if (!endpoint || !productIds) return;

      fetch(endpoint + '?product_ids=' + encodeURIComponent(productIds))
        .then(function (res) {
          if (!res.ok) throw new Error('reviews fetch failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          if (!data || !data.count) return;
          renderSummary(root, data);
          renderCards(root, (data.reviews || []).slice(0, maxQuotes));
          root.hidden = false;
        })
        .catch(function (err) {
          console.warn('[cl-reviews]', err);
        });
    });
  });
})();
